import { api, setAccessToken } from '@/lib/axios';
import type { AuthResponse, AuthUser } from './types';

export async function loginRequest(input: {
  email: string;
  password: string;
}): Promise<AuthResponse> {
  const { data } = await api.post<AuthResponse>('/auth/login', input);
  setAccessToken(data.accessToken);
  return data;
}

export async function logoutRequest(): Promise<void> {
  try {
    await api.post('/auth/logout');
  } finally {
    setAccessToken(null);
  }
}

export async function meRequest(): Promise<AuthUser> {
  const { data } = await api.get<{ user: AuthUser }>('/auth/me');
  return data.user;
}
